<template>
  <Authentication>
    <FormRegister v-if="!step" @next="next" :form="form" />
    <ResendSms v-if="step" :form="form" />
  </Authentication>
</template>

<script>
import Authentication from "../Authentication";
import FormRegister from "./FormRegister";
import ResendSms from "./ResendSms";
export default {
  name: "Register",
  components: {
    Authentication,
    ResendSms,
    FormRegister
  },
  data() {
    return {
      step: false,
      form: {
        username: { value: "", error: "" },
        phone: { value: "", error: "" },
        password: { value: "", error: "" },
        confirmPassword: { value: "", error: "" },
        policy: { value: false, error: "" },
        verifyCode: { value: "", error: "" }
      }
    };
  },
  methods: {
    next(val) {
      this.step = val;
    }
  }
};
</script>
